<template>
  <div class="invoiceLine">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="invoiceLine"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-rules="rules"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
      :valid-config="{ autoPos: true, message: 'inline' }"
      show-footer
      :footer-method="footerMethod"
    >
      <vxe-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :fixed="item.fixed"
        :visible="item.visible"
        :width="item.width || 120"
        :sortable="item.sortable"
        :field="item.field"
        :formatter="item.formatter"
        :params="item.params"
        :type="item.type"
        :title="item.title ? $t(item.title) : null"
      >
        <template slot-scope="scope">
          <span v-if="item.dictType">
            {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
          </span>
          <span v-else-if="item.format">
            {{ scope.row[item.field] | formatTableColumn(item.format) }}
          </span>
          <span v-else>{{ scope.row[item.field] }}</span>
        </template>
      </vxe-table-column>
    </vxe-grid>
  </div>
</template>
<script>
  // import InputNumber from '@/components/form-item/input-number';
  // import InputNumberAd from '@/components/form-item/input-number-advance';
  // import API from '@/api/capitalCenter/moneyDraw';

  export default {
    name: 'invoiceLine',
    components: {
      // InputNumber,
      // InputNumberAd,
    },
    props: ['paymentMethod', 'canEdit', 'sourceType', 'departmentList', 'isHnFlag'], // 付款方式，当付款方式为信用证LC禁止改付款金额 FK15
    data() {
      return {
        tableData: [],
      };
    },
    computed: {
      rules() {
        const isDiscountVaild = (rule, value, callback, { row }) => {
          if (row.isDiscount === '1') {
            row.discountRate && row.actualPaymentAmount
              ? callback()
              : callback(new Error('贴息时贴现率，贴现额必填'));
          } else {
            callback();
          }
        };

        // 付款金额校验
        const paymentAmountValid = (rule, cellValue, callback, { row }) => {
          if (cellValue > row.requestAmount) {
            callback(new Error(this.$t('paymentListAdd.message.calcInfo')));
          } else {
            callback();
          }
        };
        const valid = {
          paymentAmount: [
            {
              required: true,
              message: this.$t('paymentListAdd.invoiceLine.table.paymentAmountPlaceholder'),
            },
            { validator: paymentAmountValid },
          ],
          isDiscount: [
            {
              required: true,
              message: '请选择是否贴息',
            },
            { validator: isDiscountVaild },
          ],
        };
        return valid;
      },
      //基础数据表单配置
      columnList() {
        let cols = [
          {
            // 复选框
            type: 'checkbox',
            width: 50,
          },
          {
            // 行号
            type: 'seq',
            width: 50,
            title: this.$t('paymentListAdd.invoiceLine.table.lineNumber'),
          },
          {
            // 申请单号
            field: 'paymentApplyNumber',
            title: this.$t('paymentListAdd.invoiceLine.table.paymentApplyNumber'),
            width: 120,
          },
          {
            // 申请单行号
            field: 'paymentApplyLineNumber',
            title: this.$t('paymentListAdd.invoiceLine.table.paymentApplyLineNumber'),
            width: 120,
          },
          {
            // 部门描述
            field:
              this.sourceType == 'CL' ? 'paymentApplyDepartmentNo' : 'paymentApplyDepartmentName',
            title: this.$t('paymentListAdd.invoiceLine.table.paymentApplyDepartmentName'),
            width: 120,
            ...(this.sourceType == 'CL'
              ? {
                  editRender: {
                    name: 'ElSelect',
                    options: this.departmentList,
                    props: {
                      clearable: true,
                      filterable: true,
                    },
                    events: { change: this.departmentChange },
                  },
                }
              : {}),
          },
          {
            // 申请金额
            field: 'requestAmount',
            title: this.$t('paymentListAdd.invoiceLine.table.requestAmount'),
            width: 120,
            format: 'formatAmountRound',
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.requestAmount)}</span>];
              },
            },
          },
          {
            // 付款金额
            field: 'paymentAmount',
            title: this.$t('paymentListAdd.invoiceLine.table.paymentAmount'),
            // 付款方式不是信用证时可以修改
            ...(this.paymentMethod != 'FK15' || this.sourceType == 'CL'
              ? {
                  editRender: {
                    name: 'ElInput',
                    props: {
                      clearable: true,
                    },
                  },
                  slots: {
                    default: ({ row }) => {
                      return [
                        <span>{this.$baseRequest.formatTableColumn(row.paymentAmount)}</span>,
                      ];
                    },
                    edit: ({ row }) => {
                      return [
                        <input-number-ad
                          value={row.paymentAmount}
                          max={999999999.999999}
                          min={0}
                          onInput={(val) => this.chooseTable(val, row, 'paymentAmount')}
                        ></input-number-ad>,
                      ];
                    },
                  },
                }
              : {}),
            width: 120,
          },
          {
            // 付款金额本位币
            field: 'paymentAccountedAmount',
            title: this.$t('paymentListAdd.invoiceLine.table.paymentAccountedAmount'),
            width: 120,
            format: 'formatAmountRound',
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.paymentAccountedAmount)}</span>,
                ];
              },
            },
          },
          {
            // 汇率
            field: 'exchangeRate',
            title: this.$t('paymentListAdd.invoiceLine.table.exchangeRate'),
            width: 120,
          },
          {
            // 采购合同号
            field: 'purchaseOrderNo',
            title: this.$t('paymentListAdd.invoiceLine.table.purchaseOrderNo'),
            width: 120,
          },
          {
            // 采购合同行项目号
            field: 'purchaseOrderDetailNo',
            title: this.$t('paymentListAdd.invoiceLine.table.purchaseOrderDetailNo'),
            width: 120,
          },
          {
            // 商品描述
            field: 'productName',
            title: this.$t('paymentListAdd.invoiceLine.table.productName'),
            width: 120,
          },
          {
            // 发票编号
            field: 'invoiceCode',
            title: this.$t('paymentListAdd.invoiceLine.table.invoiceCode'),
            width: 140,
          },
          {
            // 销售合同号
            field: 'salesOrderNo',
            title: this.$t('paymentListAdd.invoiceLine.table.salesOrderNo'),
            width: 120,
          },
          {
            // 销售提单号
            field: 'salesLadingNo',
            title: this.$t('paymentListAdd.invoiceLine.table.salesLadingNo'),
            width: 120,
          },
          {
            // 币种
            field: 'currencyCode',
            title: this.$t('paymentListAdd.invoiceLine.table.currencyCode'),
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.getDictValueByType('all_currency', row.currencyCode)}
                  </span>,
                ];
              },
            },
          },
          {
            // 业务员
            field: 'businessPersonName',
            title: this.$t('paymentListAdd.invoiceLine.table.businessPersonNo'),
            width: 140,
          },
          {
            // 结算批次号
            field: 'settleBatchNo',
            title: this.$t('paymentListAdd.invoiceLine.table.settleBatchNo'),
            width: 140,
          },
          {
            // 供应商发货指令
            field: 'instructionNo',
            title: this.$t('paymentListAdd.invoiceLine.table.instructionNo'),
            width: 140,
          },
          {
            // 备注
            field: 'mark',
            title: this.$t('paymentListAdd.invoiceLine.table.mark'),
            width: 120,
          },
        ];
        if (this.isHnFlag) {
          let hnCols = [
            {
              // 是否贴息
              field: 'isDiscount',
              title: '是否贴息',
              width: 120,
              editRender: {
                name: 'ElSelect',
                options: [
                  { value: '1', label: '是' },
                  { value: '0', label: '否' },
                ],
                props: {
                  clearable: true,
                  filterable: true,
                },
              },
            },
            {
              // 贴现率
              field: 'discountRate',
              title: '贴现率',
              width: 120,
              editRender: {
                name: 'ElInput',
                props: {
                  clearable: true,
                },
              },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.discountRate}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <input-number-ad
                      value={row.discountRate}
                      max={999999999.999999}
                      onInput={(val) => this.chooseTable(val, row, 'discountRate')}
                    ></input-number-ad>,
                  ];
                },
              },
            },
            {
              // 贴现额
              field: 'actualPaymentAmount',
              title: '贴现额',
              width: 120,
              editRender: {
                name: 'ElInput',
                props: {
                  clearable: true,
                },
              },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.actualPaymentAmount}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <input-number-ad
                      value={row.actualPaymentAmount}
                      max={999999999.999999}
                      onInput={(val) => this.chooseTable(val, row, 'actualPaymentAmount')}
                    ></input-number-ad>,
                  ];
                },
              },
            },
            {
              // 贴现额本位币
              field: 'actualPaymentAccountedAmount',
              title: '贴现额本位币',
              width: 120,
            },
          ];
          cols = cols.concat(hnCols);
        }
        return cols;
      },
    },
    mounted() {},
    methods: {
      chooseTable(val, row, field) {
        row[field] = val;
        // 贴现额 = 申请金额*(1-贴现率)
        if (field == 'discountRate' || field == 'paymentAmount') {
          let discountRate = this.$cal.calCommon(
            row.discountRate,
            100,
            '/',
            this.$globalVar.ePoint
          );
          discountRate = this.$cal.calCommon(1, discountRate, '-', this.$globalVar.ePoint);
          row.actualPaymentAmount = this.$cal.calCommon(
            row.paymentAmount,
            discountRate,
            '*',
            'amount'
          );
        }
        // 计算本位币
        row.paymentAccountedAmount = this.calcLocalAmount(row.paymentAmount, row.exchangeRate);
        row.actualPaymentAccountedAmount = this.calcLocalAmount(
          row.actualPaymentAmount,
          row.exchangeRate
        );
        // 实时更新数据
        this.updateData();
      },
      departmentChange(val) {
        val.row.paymentApplyDepartmentName = val.row.paymentApplyDepartmentNo
          ? this.departmentList.find((item) => item.value == val.row.paymentApplyDepartmentNo).label
          : null;
      },
      // 计算本币
      calcLocalAmount(originAmount, exchangeRate) {
        return this.$cal.calCommon(originAmount, exchangeRate, '*', 'amount');
      },
      // 在值发生改变时更新数据
      updateData() {
        let xTable = this.$refs.invoiceLine;
        xTable.updateData();
      },
      // 合计
      footerMethod({ columns, data }) {
        let returnAmountProps = [
          'requestAmount',
          'paymentAmount',
          'paymentAccountedAmount',
          'actualPaymentAmount',
          'actualPaymentAccountedAmount',
        ];
        let amounts = {};
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex == 1) {
              return this.$t('paymentListAdd.invoiceLine.table.total');
            }
            if (returnAmountProps.includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              amounts[column.property] = subtrahend;
              if (column.property == 'paymentAccountedAmount') {
                this.$emit('getInvoiceLineAmount', amounts);
              }
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
        ];
      },
      activeRowMethod() {
        return this.canEdit;
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.invoiceLine.getTableData().fullData;
        // 点击提交，走校验
        if (tableData.length == 0) {
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.invoiceLine
              .validate()
              .then(() => {
                resolve(tableData);
              })
              .catch(() => this.loading.endLoading());
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped></style>
